/** Straight-line distance in km. */
export function distanceKm(a: { lat: number; lng: number }, b: { lat: number; lng: number }) {
  const R = 6371
  const dLat = ((b.lat - a.lat) * Math.PI) / 180
  const dLng = ((b.lng - a.lng) * Math.PI) / 180
  const h = Math.sin(dLat / 2) ** 2 + Math.cos((a.lat * Math.PI) / 180) * Math.cos((b.lat * Math.PI) / 180) * Math.sin(dLng / 2) ** 2
  return 2 * R * Math.asin(Math.sqrt(h))
}

export const directionsUrl = (lat: number, lng: number) => `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`

/** Is the station open now (Nepal time)? null when hours are unknown. */
export function openNow(hours: { day: string; open: string; close: string; closed: boolean }[], now = new Date()) {
  if (!hours?.length) return null
  const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Kathmandu', weekday: 'long', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(now)
  const day = parts.find((p) => p.type === 'weekday')!.value.toLowerCase()
  const hm = `${parts.find((p) => p.type === 'hour')!.value}:${parts.find((p) => p.type === 'minute')!.value}`
  const today = hours.find((h) => h.day === day)
  if (!today) return null
  if (today.closed) return false
  const close = today.close === '00:00' ? '24:00' : today.close
  return today.open <= close ? hm >= today.open && hm <= close : hm >= today.open || hm <= close
}
